// ---------------------------------------------------------------------------
// "Add to calendar" (§4). A single Google Calendar link carrying the full
// appointment details — title, description, location, and a real timed event
// (start + end, default 30 minutes) rather than an all-day/blank event.
// Times are practice-local (Central) and converted to UTC for the link.
// ---------------------------------------------------------------------------

import { addMinutesToStamp, centralToUtcStamp } from './dates'

export interface CalendarEvent {
  title: string
  details?: string
  location?: string
  date: string // YYYY-MM-DD (Central)
  time: string // HH:mm (Central, 24h)
  durationMinutes?: number
}

/** Build a Google Calendar "create event" URL with a 30-minute timed event. */
export function googleCalendarUrl(ev: CalendarEvent): string {
  const duration = ev.durationMinutes ?? 30
  const start = centralToUtcStamp(ev.date, ev.time)
  const endLocal = addMinutesToStamp(ev.date, ev.time, duration)
  const end = centralToUtcStamp(endLocal.ymd, endLocal.hhmm)

  const params = new URLSearchParams({
    action: 'TEMPLATE',
    text: ev.title,
    dates: `${start}/${end}`
  })
  if (ev.details) params.set('details', ev.details)
  if (ev.location) params.set('location', ev.location)

  return `https://calendar.google.com/calendar/render?${params.toString()}`
}
